import { createRouter, createWebHistory } from 'vue-router';
import { currentLang, getCache } from '@/helpers';
const routesWithPrefix = (prefix, routes) => {
    return routes.map(route => {
        route.path = `${prefix}${route.path}`;
        return route;
    });
};
const routes = [
    ...routesWithPrefix(`/${currentLang}/my-pages`, [
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/login.vue'),
            meta: {
                requiresAuth: false,
                title: 'Logga in'
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('../views/dashboard.vue'),
            meta: {
                requiresAuth: true,
                title: 'Mina sidor'
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('../views/landlord/pages/profile.vue'),
            meta: {
                requiresAuth: true,
                title: 'Min profil'
            }
        },
        {
            path: '/templates',
            name: 'templates',
            component: () => import('../views/landlord/pages/templates.vue'),
            meta: {
                requiresAuth: true,
                title: 'Mallar'
            }
        },
        {
            path: '/new-estate/:step',
            name: 'new-estate',
            component: () => import('../views/landlord/estate/estateForm.vue'),
            meta: {
                requiresAuth: true,
                title: 'Annonsera uthyrning'
            }
        },
        {
            path: '/change-estate/:estateId/:step',
            name: 'change-estate',
            component: () => import('../views/landlord/estate/estateForm.vue'),
            meta: {
                requiresAuth: true,
                title: 'Annonsera uthyrning'
            }
        },
        {
            path: '/estate/:estateId',
            name: 'estate',
            component: () => import('../views/landlord/estate/estate.vue'),
            meta: {
                requiresAuth: true,
                title: 'Annons'
            }
        },
        {
            path: '/add-tenant',
            name: 'add-tenant',
            component: () => import('../views/company/pages/tenantForm.vue'),
            meta: {
                requiresAuth: true,
                title: 'Registrera nytt sökuppdrag'
            }
        },
        {
            path: '/change-tenant/:tenantId',
            name: 'change-tenant',
            component: () => import('../views/company/pages/tenantForm.vue'),
            meta: {
                requiresAuth: true,
                title: ''
            }
        },
        {
            path: '/edit-company',
            name: 'edit-company',
            component: () => import('../views/company/pages/editCompany.vue'),
            meta: {
                requiresAuth: true,
                title: 'Annonsera uthyrning'
            }
        },
        {
            path: '/:catchAll(.*)*',
            name: '404',
            component: () => import('../views/404.vue'),
            meta: {
                requiresAuth: true,
                title: '404 | Sidan hittades inte'
            }
        }
    ]),
    {
        path: `/en/estate/:estateId`,
        name: 'estate-by-uuid-en',
        component: () => import('@views/landlord/estate/estate.vue'),
        meta: {
            requiresAuth: false,
            title: 'Annons'
        }
    },
    {
        path: `/sv/bostad/:estateId`,
        name: 'estate-by-uuid-sv',
        component: () => import('@views/landlord/estate/estate.vue'),
        meta: {
            requiresAuth: false,
            title: 'Annons'
        }
    },
    {
        path: `/en/show-interest/:estateId`,
        name: 'estate-show-interest-en',
        component: () => import('@views/company/showInterest.vue'),
        meta: {
            requiresAuth: false,
            title: 'Show interest'
        }
    },
    {
        path: `/sv/visa-intresse/:estateId`,
        name: 'estate-show-interest-sv',
        component: () => import('@views/company/showInterest.vue'),
        meta: {
            requiresAuth: false,
            title: 'Visa intresse'
        }
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            };
        }
    }
});
router.beforeEach((to, from, next) => {
    const whitelist = ['estate-by-uuid-sv', 'estate-by-uuid-en', 'estate-show-interest-sv', 'estate-show-interest-en'];
    // Apply title for each route
    document.title = `Bostad Direkt - ${to.meta.title}` || '';
    // Always make sure to scroll to the top after changing routes.
    window.scrollTo(0, 0);
    // Get cache and check the routes guards.
    const cache = getCache();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (cache && cache.access_token) {
            return next();
        }
        return next({ name: 'login' });
    }
    else {
        if (cache && cache.access_token && to.meta.requiresAuth === false && !whitelist.includes(to.name)) {
            return next({ name: 'dashboard' });
        }
        return next();
    }
});
export default router;
